import React from 'react';
import { PresetSection as PresetSectionType } from '@/config/presetConfig';
import PresetCard, { PresetInfo } from './PresetCard';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { PresetFilter } from './PresetFilter';

interface PresetSectionProps {
  section: PresetSectionType;
  activePresetId: string | null;
  onPresetSelect: (preset: PresetInfo) => void;
  onFilterChange?: (filters: {
    frequencies: string[];
    soundTypes: string[];
    durations: string[];
  }) => void;
}

const PresetSection: React.FC<PresetSectionProps> = ({
  section,
  activePresetId,
  onPresetSelect,
  onFilterChange
}) => {
  return (
    <div className="space-y-4">
      <Card className="bg-background/50 backdrop-blur-sm border-white/10">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <div>
            <CardTitle className="text-xl font-semibold">{section.title}</CardTitle>
            <CardDescription>{section.description}</CardDescription>
          </div>
          {onFilterChange && <PresetFilter onFilterChange={onFilterChange} />}
        </CardHeader>
      </Card>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-6">
        {section.presets.map((preset, index) => (
          <div 
            key={preset.id} 
            className={`animate-fade-in animate-delay-${index + 1}`}
          >
            <PresetCard
              preset={preset}
              isActive={activePresetId === preset.id}
              onClick={onPresetSelect}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PresetSection; 